/*
 * Copyright (c) 2021 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Card } from '@scuf/common';
import { GatewayIdentityApp, IGatewayIdentityAppProps } from './GatewayIdentityApp';

@inject('globalStore')
@observer
export default class GatewayIdentityWrapper extends Component<IGatewayIdentityAppProps> {


  constructor(props: IGatewayIdentityAppProps) {
    super(props);
    // This is the polyfill workaround for Promise.finally on Edge browser
    // Edge browser
    // This is fix for the issue on Microsoft edge browser. It causes a lint issue.
    // @Todo Find a polyfill for browser incompatibilities
    if (!Promise.prototype.finally) {
      Promise.prototype.finally = function (fn: any) {
        const onFinally = (value: any) => Promise.resolve(fn()).then(() => value);
        return this.then(
          (result: any) => onFinally(result),
          (reason: any) => onFinally(Promise.reject(reason))
        );
      };
    }
  }

  render() {
    return (this.props.globalStore!.envVariables) ?
      <GatewayIdentityApp globalStore={this.props.globalStore} /> :
      this.getAppLoadingMessage();
  }

  private getAppLoadingMessage = () => {
    return <div className="ui-msg-block"><Card>
      <Card.Content>
        <div className="ui-loading-msg">
          Initializing application
            </div>
      </Card.Content>
    </Card></div>;
  };

}

